<div class="my-bets-used-reward-token__icon">
    @if (iconClasses.icon) {
        <vn-icon size="20" [ngClass]="iconClasses.extraClass" [name]="iconClasses.icon" />
    }
</div>
<div class="my-bets-used-reward-token__description">
    <div>{{ description }}</div>
    @if (isResettled) {
        <div>{{ rewardUsedResettledInfo }}</div>
    }
</div>
@if (showDetails) {
    <div class="my-bets-used-reward-token__payout-details">
        <div class="my-bets-used-reward-token__payout-description">
            <div [innerHTML]="detailsText"></div>
            @if (showCashoutDetails) {
                <div class="my-bets-used-reward-token__cashout-description">{{ cashingOutDescriptionRiskFree }}</div>
            }
        </div>
    </div>
}
